module.exports = __webpack_public_path__ + "img/8_11.ad9ac00b.png";